<template>
  <div
    class="tw-rounded-sm tw-bg-white tw-pt-4 tw-h-full"
    :data-test-id="`${tier}-sat-chart`"
  >
    <card-placeholder-banner
      type="SAT"
      :data-test-id="`${tier}-sat-banner`"
      :data-test-id-base="`${tier}-sat`"
    >
      <template #title>{{ $t("sat-label") }}</template>
      <template #text>
        {{ $t("dashboard-sat") }}
      </template>
    </card-placeholder-banner>
    <div class="tw-p-4">
      <div
        id="sat-appcues-placeholder"
        class="tw-flex tw-items-center tw-justify-center tw-py-10 tw-text-gray-400"
      >
        <cl-icon-empty-graph :width="128" color="currentColor" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CardPlaceholderBanner from "../CardPlaceholderBanner/CardPlaceholderBanner.vue";
import { useIsMspRoute } from "@/composables/useIsMspRoute";

const { isMspRoute } = useIsMspRoute();

const tier = isMspRoute.value ? "msp" : "customer";
</script>
